module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/4@2x_93fb971dc4cdfd1709254acac0ca3954.png";